import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import {
  MAT_LEGACY_DIALOG_DATA,
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'csl-product-model-viewer-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatExpansionModule,
    MatTooltipModule,
    FlexLayoutModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './product-model-viewer-dialog.component.html',
  styleUrls: ['./product-model-viewer-dialog.component.scss'],
})
export class ProductModelViewerDialogComponent implements OnInit {
  @ViewChild('viewer', { static: true }) viewer: ElementRef;

  animations: string[] = [];
  materials: any[] = [];
  exposure = 0.5;
  activeAnimation = '';

  delay(ms: number): Promise<unknown> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  playAnimation(animantionName: string): void {
    this.activeAnimation = animantionName;

    this.viewer.nativeElement.pause();
    this.viewer.nativeElement.setAttribute('animation-name', animantionName);
    this.viewer.nativeElement.play();
  }

  pauseAnimation(): void {
    this.activeAnimation = '';
    this.viewer.nativeElement.pause();
  }

  stopAnimation(): void {
    this.activeAnimation = '';

    this.viewer.nativeElement.pause();
    this.viewer.nativeElement.currentTime = 0;
    this.viewer.nativeElement.setAttribute('animation-name', '');
    this.viewer.nativeElement.play();
    this.viewer.nativeElement.pause();
  }

  async playAll(): Promise<void> {
    for (let i = 0; i < this.animations.length; i++) {
      if (i === 0 || this.viewer.nativeElement.getAttribute('animation-name') !== '') {
        this.playAnimation(this.animations[i]);
        await this.delay(1900);
      }
    }
    this.viewer.nativeElement.pause();
  }

  constructor(
    public dialogRef: MatDialogRef<ProductModelViewerDialogComponent>,
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: { modelUrl: string }
  ) {}

  onModelLoading(): void {
    this.animations = this.viewer.nativeElement.availableAnimations;

    console.warn(this.viewer.nativeElement.model);
    this.materials = this.viewer.nativeElement.materials;
  }

  setModelLinks(): void {
    this.viewer.nativeElement.src = this.data.modelUrl;
    // this.viewer.nativeElement.poster = ApiLinks.modelImage(this.projectId, this.guid);
  }

  ngOnInit(): void {
    this.viewer.nativeElement.addEventListener('load', () => {
      this.onModelLoading();
    });

    this.setModelLinks();
  }
}
